import type { CreateClientConfig } from '../generated/notification-pref/client/types.gen';

/**
 * Runtime configuration for the generated notification preference client.
 * See `./pap.runtime.ts` for details on how this is wired up.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: '/api/notifications/preferences',
});
